import React, { Component } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import without from 'lodash/without';
import partial from 'lodash/partial';
import ProjectLink from 'common/containers/project_link';

export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: [] };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle(projectId) {
    const { expanded } = this.state;
    if (expanded.includes(projectId)) {
      this.setState({ expanded: without(expanded, projectId) });
    } else {
      this.setState({ expanded: expanded.concat(projectId) });
    }
  }

  render() {
    const { invoices } = this.props;
    const { expanded } = this.state;
    const byProject = groupBy(invoices, invoice => invoice.data.project.reference);
    /* projects with latest invoices first */
    const sortedKeys = sortBy(
      Object.keys(byProject), projectId => -moment(byProject[projectId][0].updated_at)
    );
    const visibleInvoices = sortedKeys.reduce((acc, projectId, i) => {
      const projectInvoices = byProject[projectId];
      let visibleProjectInvoices = [];
      const isExpanded = expanded.includes(projectId);
      const rowClass = (i + 1) % 2 === 0? 'even' : 'odd';

      visibleProjectInvoices.push({
        ...projectInvoices[0],
        isLatest: true,
        onToggle: projectInvoices[1]? partial(this.handleToggle, projectId) : undefined,
        isExpanded,
        rowClass
      });

      if (isExpanded) {
        visibleProjectInvoices = visibleProjectInvoices.concat(
          projectInvoices.slice(1).map(invoice => ({ ...invoice, rowClass }))
        );
      }

      return acc.concat(visibleProjectInvoices);
    }, []);

    return (
      <table className="table table-default actionable table-invoices">
        <thead>
          <tr>
            <td>Project</td>
            <td>Amount</td>
            <td className="hide-for-small-only">Date</td>
            <td>Receipt</td>
          </tr>
        </thead>
        <tbody>
          { visibleInvoices.map((invoice, i) => {
            const { data, updated_at, pdf, onToggle, isExpanded, isLatest, rowClass } = invoice;
            const project = {
              title: data.project.title,
              id: data.project.reference,
              sub_category: data.project.sub_category,
              slug: data.project.slug
            };

            return (
              <tr key={i} className={classnames(rowClass, { "latest": isLatest })}>
                <td><ProjectLink project={project}/></td>
                <td>{ data.billed.total }</td>
                <td className="hide-for-small-only">
                  { moment(updated_at).format('MMMM DD, YYYY') }
                </td>
                <td>
                  <a href={pdf} target="_blank"><i className="fa fa-file-pdf-o"></i>
                    <span className="hide-for-small-only"> PDF</span>
                  </a>
                  { onToggle &&
                  <i onClick={onToggle} className={"fa fa-angle-" + (isExpanded? "down" : "up")} /> }
                </td>
              </tr>)
          }) }
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./account/components/payment_history.jsx